module.exports = __webpack_public_path__ + "img/Time.97c7cd15.svg";